export default __webpack_public_path__ + "static/media/step3.5c6b565a.gif";